// extracted by css-extract-rspack-plugin
export default {"table":"UyOYs","nameHeader":"Ad2ti","scoreHeader":"tb197"};